<template>
  <b-navbar :toggleable="false" type="light" class="navbar">
    <b-navbar-brand :to="{ name: 'home' }">
      <img :src="logo" class="d-inline-block align-top vitu-logo" alt="Logo" />
      <span class="title">Datenspende</span>
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto">
      <b-nav-item :href="$t('imprintUrl')" target="_blank">{{ $t("imprint") }}</b-nav-item>
      <locale-switcher />
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import LocaleSwitcher from "../components/LocaleSwitcher";
import logoMolit from "../assets/Molit_Logo.png";

export default {
  components: {
    LocaleSwitcher
  },
  computed: {
    logo() {
      return logoMolit;
    }
  }
};
</script>
<style lang="scss">
.navbar-nav {
  display: inherit;
  flex-direction: initial;
}
</style>

<style lang="scss" scoped>
.navbar {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.vitu-logo {
  height: 30px;
}
.title {
  margin-left: 1rem;
}
</style>
